exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.block[data-v-149c046e] {\n  background: white;\n  padding: 5px 25px;\n}\n.block-header[data-v-149c046e] {\n  padding: 20px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.block-header-title[data-v-149c046e] {\n  padding: 0;\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n", ""]);

// exports
